import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";

export namespace IDeviceStats {
  export enum Action {
    DeviceStats = 'deviceStats',
  }

  export enum Command {
    DeviceStats = 'deviceStats',
  }

  export interface IState {
    loading: boolean;
    tableData: IEntity[];
    tableName: string;
    sortingTable: IAppTable.ISortingData;
  }

  export interface IEntity {
    orderId: number;
    errFlag: number;
    type: string;
    errCount: number;
    parkName: string;
    cameras?: string;
    duration?: string;
    dateBeg?: string;
    dateEnd?: string;
  }
}